
import { 
  normalizeText as utilNormalize,
  sanitizeForTTS as utilSanitize,
  estimateDuration as utilEstimate,
  validateTextForTTS as utilValidate,
  preprocessTextForTTS as utilPreprocess,
  getLanguageBreakdown as utilGetLanguageBreakdown
} from '@/utils/textProcessing';

/**
 * Pure text normalization for audio processing
 */
export const normalizeText = (text: string): string => {
  return utilNormalize(text);
};

/**
 * Pure text sanitization for TTS - removes section labels
 */
export const sanitizeForTTS = (text: string): string => {
  return utilSanitize(text);
};

/**
 * Pure duration estimation in seconds
 */
export const estimateDuration = (text: string): number => {
  return utilEstimate(text);
};

/**
 * Pure text validation for TTS suitability
 */
export const validateForTTS = (text: string): { isValid: boolean; reason?: string } => {
  return utilValidate(text);
};

/**
 * Pure text preprocessing for optimal TTS
 */
export const preprocessForTTS = (text: string): string => {
  return utilPreprocess(text);
};

/**
 * Pure function to analyze language breakdown
 */
export const getLanguageBreakdown = (text: string) => {
  return utilGetLanguageBreakdown(text);
};
